module.exports = __webpack_public_path__ + "img/cajaChicasSantiagoVV.06cdad67.svg";